import { createContext, useContext, useState, ReactNode } from 'react';
import { AgendaItem } from '../types';
import { agendaItems } from '../data/agenda';

interface AgendaContextValue {
  agendaItems: AgendaItem[];
  currentItem: AgendaItem | null;
  getCurrentItem: () => AgendaItem | null;
  refreshCurrentItem: () => void;
}

export const AgendaContext = createContext<AgendaContextValue | undefined>(undefined);

interface AgendaProviderProps {
  children: ReactNode;
}

export function AgendaProvider({ children }: AgendaProviderProps) {
  const [currentItem, setCurrentItem] = useState<AgendaItem | null>(() => {
    const now = new Date();
    const activeItem = agendaItems.find(
      item => now >= item.startTime && now < item.endTime
    );
    return activeItem || null;
  });

  const getCurrentItem = (): AgendaItem | null => {
    const now = new Date();
    
    // Find the agenda item where current time is between startTime and endTime
    const activeItem = agendaItems.find(
      item => now >= item.startTime && now < item.endTime
    );
    
    return activeItem || null;
  };

  const refreshCurrentItem = () => {
    const newItem = getCurrentItem();
    setCurrentItem(newItem);
  };

  const value: AgendaContextValue = {
    agendaItems,
    currentItem,
    getCurrentItem,
    refreshCurrentItem,
  };

  return (
    <AgendaContext.Provider value={value}>
      {children}
    </AgendaContext.Provider>
  );
}

export function useAgenda() {
  const context = useContext(AgendaContext);
  if (context === undefined) {
    throw new Error('useAgenda must be used within an AgendaProvider');
  }
  return context;
}
